export default __webpack_public_path__ + "static/media/dog3.e6e05c3f.png";